<template>
  <ClientOnly>
    <!-- Client: animated count (only when visible) -->
    <div ref="el">
      {{ Math.round(n).toLocaleString() }}
    </div>

    <!-- SSR / no-JS: final number for SEO -->
    <template #fallback>
      <div>
        {{ props.to.toLocaleString() }}
      </div>
    </template>
  </ClientOnly>
</template>

<script setup>
import {
  useElementVisibility,
  useTransition,
  TransitionPresets,
  watchOnce,
} from "@vueuse/core";

const props = defineProps({
  to: { type: Number, required: true },
  duration: { type: Number, default: 1000 },
});

const el = ref();
const seen = useElementVisibility(el);

const target = ref(0);
const n = useTransition(target, {
  duration: props.duration,
  transition: TransitionPresets.easeOutQuad,
});

watchOnce(seen, () => {
  target.value = props.to;
});
</script>
